import React from 'react';
import { METRIKA_GOALS, reachGoal } from '../analytics';

const stages = [
  {
    index: '01',
    label: 'Предварительная квалификационная встреча',
    title: 'Проверить задачу и формат',
    description:
      'Бесплатно за 20–30 минут уточняем контекст и определяем, есть ли основания переходить к аудиту.',
  },
  {
    index: '02',
    label: 'Аудит · диагностика · план',
    title: 'Выбрать первый контур',
    description:
      'Определяем приоритетные сценарии, оцениваем готовность и проектируем план внедрения.',
  },
  {
    index: '03',
    label: 'Реализация',
    title: 'Внедрить и проверить MVP',
    description:
      'Вместе с командой заказчика собираем решение и проверяем согласованные критерии результата.',
  },
];

function Solutions() {
  return (
    <section id="solutions" className="section corporate-section">
      <div className="corporate-intro">
        <div className="section-heading">
          <p className="eyebrow">03 / ИИ для компаний</p>
          <h2>От управленческой задачи к обоснованному плану и работающему MVP</h2>
        </div>
        <p className="intro-note">
          Аудит и реализация — два отдельных этапа. Каждый следующий шаг
          начинается только после совместного решения по итогам предыдущего.
        </p>
      </div>

      <div className="corporate-steps">
        {stages.map((stage) => (
          <article className="corporate-step" key={stage.index}>
            <span className="corporate-step-index">{stage.index}</span>
            <p className="corporate-step-label">{stage.label}</p>
            <h3>{stage.title}</h3>
            <p>{stage.description}</p>
          </article>
        ))}
      </div>

      <div className="corporate-principle">
        <div>
          <span className="block-tag">Принцип работы</span>
          <h3>Внедрение делается вместе с командой заказчика</h3>
        </div>
        <div className="corporate-principle-copy">
          <p>
            Мы берём на себя метод, проектирование и технологическую часть
            согласованного этапа. Компания сохраняет роль владельца задачи и
            предоставляет бизнес-контекст, экспертов, процессы и данные.
          </p>
          <div className="corporate-actions">
            <a
              className="button button-primary"
              href="/ai/"
              data-metrika-goal={METRIKA_GOALS.SELECT_AI}
              onClick={() => reachGoal(METRIKA_GOALS.SELECT_AI)}
            >
              Как проходит внедрение
            </a>
            <a
              className="button button-secondary"
              href="/ai/#corporate-contact"
              data-metrika-goal={METRIKA_GOALS.SELECT_AI}
              onClick={() => reachGoal(METRIKA_GOALS.SELECT_AI)}
            >
              Обсудить задачу компании
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Solutions;
